import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=35bb16d6&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=35bb16d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb16d6",
  null
  
)

export default component.exports